import { render } from "./LeaveRequest.vue?vue&type=template&id=5cf2c6b8&scoped=true"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"

import "./LeaveRequest.vue?vue&type=style&index=0&id=5cf2c6b8&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf2c6b8"]])

export default __exports__